angular.module('arachne.controllers', []);
angular.module('arachne.directives', []);
angular.module('arachne.filters', []);
angular.module('arachne.resources', []);
angular.module('arachne.services', []);
angular.module('arachne.widgets.directives', []);
angular.module('arachne.widgets.map', []);
